module.exports = __webpack_public_path__ + "abb9457562a9049db4c9f5e4d471ecf6.woff2";